<template>
  <div class="hb-text-night">
    <div v-for="ins in insurances" :key="ins.id">
      <hb-radio
        v-if="showRadioButton"
        :value="ins"
        :name="ins.id"
        :id="ins.id"
      >
        <template v-slot:content>
          <TableRateLabel
            :insurances="insurances"
            :isSelected="isSelected"
            :coverageAmount="coverageAmount"
            @updateCoverageValue="updateCoverageValue"
            @onClearInput="onClearInput"
            :coverageOptionType="coverageOptionType"
          />
        </template>
      </hb-radio>
      <div v-if="!showRadioButton">
        <TableRateLabel
          :insurances="insurances"
          :isSelected="isSelected"
          :coverageAmount="coverageAmount"
          @updateCoverageValue="updateCoverageValue"
          @onClearInput="onClearInput"
          :coverageOptionType="coverageOptionType"
        />
      </div>
    </div>
    <div :class="['table-rate-tiers','mb-4', { 'full-width': fullWidth }, { 'tiers-small-font': tiersSmallFont}]">
      <v-row no-gutters v-for="(item, index) in insurances[0]?.TableRateTiers" :key="index">
        <v-col class="hb-text-light" cols="5">${{ item.coverage_limit_start | formatMoneyWithComma(0) }} - ${{ item.coverage_limit  | formatMoneyWithComma(0)}}</v-col>
        <v-col class="hb-text-light coverage-rate" cols="7">${{ item.premium_rate | formatMoneyWithComma(2) }} per ${{ item.coverage_unit | formatMoneyWithComma(0) }} Coverage</v-col>
      </v-row>
    </div>
  </div>
</template>

<script type="text/babel">
  import TableRateLabel from './TableRateLabel.vue';

  export default {
    name: "TableRateInsurance",
    components: {
      TableRateLabel
    },
    methods: {
      updateCoverageValue(coverageValue){
        if(coverageValue <=0 && this.coverageOptionType == 'send_quote'){
          coverageValue = 0;
        }else{
          coverageValue *= (this.insurances.length ? this.insurances[0]?.TableRateTiers[0]?.coverage_unit : 1000);
        }
        this.$emit('updateCoverageValue', coverageValue);
      },
      onClearInput(){
        this.$emit('updateCoverageValue', 0);
      }
    },
    props: {
      insurances: {
        type: Array,
        required: true
      },
      isSelected: {
        type: Boolean,
        required: true
      },
      fullWidth: {
        type: Boolean,
        default: false
      },
      showRadioButton: {
        type: Boolean,
        default: true
      },
      tiersSmallFont: {
        type: Boolean,
        default: false
      },
      coverageAmount: {
        type: Number,
        default: 0
      },
      coverageOptionType: {
        type: String,
        default: ''
      },
    }
  }
</script>

<style scoped>
  .table-rate-tiers {
    border: 1px solid #DFE3E8;
    padding: 1.2rem;
    border-radius: 4px;
    width: 80%;
    font-size: 13px;
  }
  .coverage-rate {
    display: flex;
    justify-content: flex-end;
  }
  .full-width {
    width: 100% !important
  }
  .tiers-small-font {
    font-size: 11px;
    font-weight: 500;
  }
</style>